import React, { useEffect } from 'react';

import EmptyState from '~/components/EmptyState';
import { CampaignType, DiallerType } from '~/pages/CampaignManagement/domain';
import DetectMicrophone from '~components/DetectMicrophone';
import PopUpEnforcer from '~components/PopUpEnforcer';
// import AsteriskDialler from '~pages/Dialler/AsteriskDialler';
import AsteriskDiallerV2 from '~pages/Dialler/AsteriskDiallerV2';
import ConnectDialler from '~pages/Dialler/ConnectDialler';
import AgentStatesProvider from '~providers/AgentStatesProvider';
import { AssignedDiallerGroupProvider, useAssignedDiallerGroup } from '~providers/AssignedDiallerGroupProvider';
import AsteriskDiallerProvider from '~providers/AsteriskDiallerProvider';
import { AsyncProvider } from '~providers/AsyncProvider';
import { AttemptProvider } from '~providers/AttemptProvider';
import { useAuth } from '~providers/AuthProvider';
import ConnectProvider from '~providers/ConnectProvider';
import { useSetPageTitleProps } from '~providers/PageTitleProvider';
import ScreenShareProvider from '~providers/ScreenShareProvider';

const DiallerSwitch = () => {
  const { group } = useAssignedDiallerGroup();
  const { username: loggedInUserUsername } = useAuth();

  switch (group.diallerType) {
    case DiallerType.Connect: {
      return (
        <DetectMicrophone>
          <PopUpEnforcer>
            <ScreenShareProvider>
              <ConnectProvider>
                <AsyncProvider enabled={group.hasAsyncQueues && group.campaignType !== CampaignType.Predictive}>
                  <AgentStatesProvider>
                    <AttemptProvider loggedInUserUsername={loggedInUserUsername}>
                      <ConnectDialler />
                    </AttemptProvider>
                  </AgentStatesProvider>
                </AsyncProvider>
              </ConnectProvider>
            </ScreenShareProvider>
          </PopUpEnforcer>
        </DetectMicrophone>
      );
    }
    case DiallerType.SIP: {
      return (
        <DetectMicrophone>
          <PopUpEnforcer>
            <ScreenShareProvider>
              <AsteriskDiallerProvider>
                <AsteriskDiallerV2 />
              </AsteriskDiallerProvider>
              {/*<AsteriskDialler />*/}
            </ScreenShareProvider>
          </PopUpEnforcer>
        </DetectMicrophone>
      );
    }
    default: {
      return (
        <EmptyState
          type='puzzle'
          text='User Configuration Error'
          subText='You are not assigned to a dialling campaign.'
        />
      );
    }
  }
};

const Dialler = () => {
  const setPageTitleProps = useSetPageTitleProps();

  // Set page title
  useEffect(() => {
    setPageTitleProps({ pageName: 'Dialler' });
  }, []);

  return (
    <AssignedDiallerGroupProvider>
      <DiallerSwitch />
    </AssignedDiallerGroupProvider>
  );
};

export default Dialler;
